module.exports = __webpack_public_path__ + "static/img/21.48a5303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/21.jpg
// module id = XBdK
// module chunks = 16